import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";

const AddAgesPopup = ({ isOpen, onRequestClose, des }) => {
  const navigate = useNavigate();
  const [selectedAges, setSelectedAges] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log("des", des);

  // Generate age list from 18 to 100
  const ageOptions = Array.from({ length: 83 }, (_, i) => 18 + i);

  const toggleAgeSelection = (age) => {
    setSelectedAges((prevSelected) =>
      prevSelected.includes(age)
        ? prevSelected.filter((a) => a !== age)
        : [...prevSelected, age]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data"))?.token;

    const payload = selectedAges.map((age) => ({
      packageid: des?.pkg?.packageid,
      designationid: des?.designation?.designationId,
      gender: des?.gender,
      age,
    }));

    try {
      await axios.post("/api/packagedesignationmapping/create", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Age Added successfully");
      setSelectedAges([]);
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data?.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Ages</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-floating-sm mb-2">
                    <label>Designation</label>
                    <input
                      className="form-control"
                      type="text"
                      value={des?.designation?.designation || ""}
                      readOnly
                    />
                  </div>

                  <div className="form-floating-sm mb-2">
                    <label>Package</label>
                    <input
                      className="form-control"
                      type="text"
                      value={des?.pkg?.pac?.packagename || ""}
                      readOnly
                    />
                  </div>

                  <div className="form-floating-sm mb-2">
                    <label>Gender</label>
                    <input
                      className="form-control"
                      type="text"
                      value={des?.gender || ""}
                      readOnly
                    />
                  </div>

                  <div className="mb-2">
                    <label>
                      Age <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="dropdown">
                      <button
                        className="form-control text-start dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {selectedAges.length > 0
                          ? selectedAges.sort((a, b) => a - b).join(", ")
                          : "Select Age(s)"}
                      </button>
                      <ul
                        className="dropdown-menu p-2"
                        style={{
                          maxHeight: "200px",
                          overflowY: "auto",
                          width: "100%",
                        }}
                      >
                        {ageOptions.map((age) => (
                          <li key={age} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={age}
                              id={`age-${age}`}
                              checked={selectedAges.includes(age)}
                              onChange={() => toggleAgeSelection(age)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`age-${age}`}
                            >
                              {age}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "SAVE"}
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button variant="secondary" onClick={onRequestClose}>
                    Close
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddAgesPopup;
